module.exports = __webpack_public_path__ + "static/media/dsb-CIDER.d03e577c.jpg";